export default __webpack_public_path__ + "static/media/auBE.a9381a06.png";